export default __webpack_public_path__ + "static/10-5bcb1b67309418b8b9c4bdc72624fce8.jpg";